import { publicEnv } from '~/features/environment/public';

export const WOOLF_DEGREE_IDS = {
  production: {
    MastersInAI: '4774d824-8bc6-4f7e-b5e0-ae42dbddc257',
    MBA: 'a643f0fa-25ff-4dc5-8564-a2112becaa77',
  },
  sandbox: {
    MastersInAI: 'cb9a7c6d-702f-47b2-b0f4-09725f464025',
    MBA: 'f32b39c6-c1b1-41e3-bc75-67089454aaf6',
  },
} as const;

const isProductionWoolf =
  publicEnv.NEXT_PUBLIC_ENVIRONMENT_NAME === 'production' || publicEnv.NEXT_PUBLIC_ENVIRONMENT_NAME === 'preview';

export const WoolfDegreeId = isProductionWoolf ? WOOLF_DEGREE_IDS.production : WOOLF_DEGREE_IDS.sandbox;
